import
  React, {
  useContext,
  useEffect,
  useState
} from 'react';

import {
  useLocation
} from 'react-router-dom';

import {
  JourneyProvider
} from '@vodacom/web-common';

import {
  getStorageWithExpiry,
  useRedirectHandler
} from 'helpers';

import {
  AirtimeAdvancePrompt
} from 'components';

import {
  AppContext
} from 'context';

export const RedirectHandler = () => {

  const location = useLocation();
  const {
    config,
    bundleBalances
  } = useContext(AppContext);

  const redirectHandler = useRedirectHandler();
  const returnUrl = getStorageWithExpiry('Prompt', 'returnUrl');

  const [ state, setState ] = useState({
    isError: false,
    url: location.state?.url || JourneyProvider.get('Prompt', 'url'),
    isZeroRated: location.state?.isZeroRated,
    userType: getStorageWithExpiry('msisdn', 'msisdnType', 'PREPAID'),
    userAirtimeBalance: 0
  });

  const handlePrompt = () => {

    JourneyProvider.set('Prompt', { url: state.url });

    setState(prevState => ({
      ...prevState,
      userAirtimeBalance: bundleBalances?.airtimeBalance
    }));
  };

  useEffect(() => {

    handlePrompt();

  }, []);

  return (

    <AirtimeAdvancePrompt
      headerText={config?.advancePromptConfig?.promptHeaderText}
      bodyText={config?.advancePromptConfig?.promptBodyText}
      pageName={'cbu: connectu: airtime advance: get information screen'}
      tagViewData={{
        page_section: 'airtime advance',
        visitor_customer_segment: state.userType,
        visitor_type: 'consumer',
        visitor_id_asset_active: getStorageWithExpiry('msisdn', 'hashedMsisdn', ''),
        user_balance: parseFloat(state.userAirtimeBalance?.replace?.(/[^0-9.-]+/g, ''))
      }}
      renderModal={true}
      onClose={() => {
        redirectHandler(returnUrl, state.url, state.isZeroRated, true);
      }}
    />
  );
};
